import React from 'react';
import { LegalLayout } from '@/components/LegalLayout';

export default function TermsPage() {
  return <LegalLayout ns="terms" seo="terms" testId="terms-page" />;
}
